import { Injectable, inject } from '@angular/core';
import { CartQuotationFacade } from '@/app/features/shared/quotation/facades/cart-quotation.facade';

@Injectable({ providedIn: 'root' })
export class PublicNavbarFacade {
  private readonly cartQuotationFacade = inject(CartQuotationFacade);

  readonly searchClearedAt = this.cartQuotationFacade.searchClearedAt;

  searchOrQuote(value: string): void {
    this.cartQuotationFacade.searchOrQuote(value);
  }
}
